import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { IGlobalState } from '../types'

export const getters: GetterTree<IGlobalState, RootState> = {}

export default getters
